

export default function basicNavigation() {

    const $navbarSearchToggle = $('.toggle-search');
    const $navbarSearchToggleButton = $('.nav-link.toggle-search');
    const $navbarSearch = $('.navbar-search');
    const $navbar = $('.navbar');
    const $navbarCollapse = $('.navbar .navbar-collapse');
    const $navbarSearchCollapseButton = $('.navbar-search-close');
    const $window = $(window);

    let navbarTogglable = $navbar.hasClass('navbar-togglable');
    let navbarState = 'dark';
    let navbarCollapsed = false;

    const setNavbarLight = () => {
        if (navbarTogglable && navbarState !== 'light') {
            $navbar.removeClass('navbar-dark').addClass('navbar-light');
            navbarState = 'light';
        }
    };

    const setNavbarDark = () => {
        if (navbarTogglable && navbarState !== 'dark') {
            $navbar.removeClass('navbar-light').addClass('navbar-dark');
            navbarState = 'dark';
        }
    };

    const setNavbarState = (action) => {
        let scrollTop = $window.scrollTop();
        if (scrollTop > 10) {
            setNavbarLight();
        } else {
            if (action === 'scroll' && !navbarCollapsed) setNavbarDark();
            if (action === 'collapse' && !navbarCollapsed) setNavbarLight();
            if (action === 'collapse' && navbarCollapsed) setNavbarDark();
        }
    };

    $window.on('scroll', () => setNavbarState('scroll'));

    $window.on('load', () => setNavbarState('scroll'));

    $navbarCollapse.on('show.bs.collapse', () => {
        setNavbarState('collapse');
        $navbar.css('height', 'auto');
        navbarCollapsed = true;
    });

    $navbarCollapse.on('hide.bs.collapse', () => {
        setNavbarState('collapse');
        $navbar.css('height', 'auto');
        navbarCollapsed = false;
    });

    $navbarSearchCollapseButton.on('click', function (e) {
        e.preventDefault();
        $navbarSearch.css('z-index','100');
        $navbarSearch.removeAttr('style');
        $('body').toggleClass("show-search");

    });

    $navbarSearchToggleButton.on('click', function(e){
        e.preventDefault();
        $('body').toggleClass("show-search");
        setTimeout(()=>($navbarSearch.find('input[type=search]').focus()), 450);
        setTimeout(function(){$navbarSearch.css('z-index','1036')}, 500);
    });

}